import { createAction, props } from '@ngrx/store';
import { AppError } from 'src/app/errors/app-error';
import { GetTopicRequest, GetTopicResponse } from '../models/topic';

export const getTopic = createAction('[Topic] Get Topic', props<{ request: GetTopicRequest }>());
export const getTopicSuccess = createAction('[Topic] Get Topic Success', props<{ response: GetTopicResponse }>());
export const getTopicFailure = createAction('[Topic] Get Topic Failure', props<{ error: AppError }>());
export const initializeGetTopicState = createAction('[Topic] Initialize Get Topic State');
